export default __webpack_public_path__ + "static/media/logo-lg.0601bf10.png";